export default {
  inject: ['keyField', 'showField', 'renderCell', 'rtl', 'inPicked'],
  props: {
    list: Array,
    picked: Array,
    dropHeight: Number,
    value: Number
  },
  methods: {
    rowClick: function rowClick(row) {
      this.$emit('select', row);
    },
    rowClass: function rowClass(row, index) {
      return {
        'sp-over': this.value === index,
        'sp-selected': this.inPicked(row),
        'sp-rtl': this.rtl
      };
    },
    highlight: function highlight(index) {
      this.$emit('input', index);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/dic/mixins/view.js
// module id = 2
// module chunks = 0